"use strict";

import { builderVersion } from '../version.json';

module.exports = function ($stateProvider) {
    $stateProvider.state("dashboard.sheets", {
        url: "/sheets",
        templateUrl: "dashboard-sheets/dashboard-sheets.html",
        controller: "dashboardSheetsCtrl as ctrl",
        cache: false,
        resolve: {
            // tenantCheck: ["user", "$state", "$q", function (user, $state, $q) {
            //     const VOOLKS_TENANT_ID = "56fc21e402a3885f336d8d3f";
            //     if (!user || user.tenantId !== VOOLKS_TENANT_ID) {
            //         $state.go("dashboard");
            //         return $q.reject(new Error("Usuario no pertenece al tenant Voolks"));
            //     }
            //     return $q.resolve(true);
            // }],
            clients: ["Client", "Authentication", function (Client, Authentication) {
                return Client.find({
                    filter: {
                        where: { isOU: true },
                        include: ["owners"],
                        order: "name ASC",
                    },
                })
                .$promise.then(function (clients) {
                    if (clients.length == 0) return null;
                    if (Authentication.isAuthorized(["admin"])) return clients;
                    return clients.filter((clt) =>
                        clt.owners.find((owner) => owner.id == Authentication.currentUser())
                    );
                });
            }],
            departments: ["Department", "Authentication", function (Department, Authentication) {
                return Department.find({
                    filter: {
                        include: ["client"],
                        order: "name ASC",
                    },
                }).$promise.then(function (departments) {
                    if (Authentication.isAuthorized(["admin"])) return departments;
                    // Filtrar según permisos del usuario
                    return departments;
                });
            }],
            // filesFromApi: ["user", "$http", "tenantCheck", "Authentication", "siteConfig", function (user, $http, tenantCheck, Authentication, siteConfig) {
            filesFromApi: ["user", "$http", "Authentication", "siteConfig", function (user, $http, Authentication, siteConfig) {
                const SHEETS_API_BASE = siteConfig.sheetsApiBase;
                const url = SHEETS_API_BASE + "/files/tenant/" + (user && user.tenantId ? user.tenantId : "");

                const headers = {
                    'Authorization': 'Bearer ' + (Authentication.getAccessToken ? Authentication.getAccessToken() : ''),
                    'systemId': 'builder',
                    'systemVersion': builderVersion,
                    'userId': user ? user.id : '',
                };

                return $http.get(url, { headers: headers }).then(function (res) {
                    return Array.isArray(res.data) ? res.data : [];
                }, function () {
                    return [];
                });
            }],
        },
        data: {
            authorizedRoles: ["admin", "owner", "fieldAdmin"],
        },
    });
};

